import React from "react";
import MediaCard from "../common/MediaCard";
import FadeIn from "../Animations/FadeIn";

export default function MediaItemsContainer({ mediaItemsData, selectedYear, mainArticle }) {
	return (
		<FadeIn
			customClass={`media-container 
			${mediaItemsData && mediaItemsData.length == 0 ? "no-matching-data" : ""}
			${selectedYear && selectedYear != "all" ? "decrease-margin" : ""}
			`}
		>
			{mediaItemsData?.sort((a, b) => (new Date(b.attributes.date) - new Date(a.attributes.date))).map((item, index) =>
				<MediaCard
					key={index}
					cardData={item?.attributes}
					index={index}
				/>
			)}
			{mediaItemsData?.length == 0 && !mainArticle && (
				<div className="no-matching-text _eleX">No Matching Results</div>
			)}
		</FadeIn>
	);
}
